import ChatTemplate from "components/shared/chat";
import { chatContainer } from "helpers/redux";
import { withRouter } from "react-router-dom";

class Chat extends ChatTemplate {}

export default withRouter(chatContainer(Chat));
